import TableCell from "@mui/material/TableCell";
import { styled } from "../../../../lib/styled";

/** Monospace table cell for numeric/code data in trace tables. */
export const MonoCell = styled(TableCell)({
  fontFamily: "monospace",
});

/** Collapsible table cell that removes its border when collapsed. */
export const CollapsibleCell = styled(TableCell)<{ $open: boolean }>(({ $open }) => ({
  paddingTop: 0,
  paddingBottom: 0,
  borderBottom: $open ? undefined : "none",
}));

/** Inner wrapper for Collapse content in trace table rows. */
export const CollapseInner = styled("div")(({ theme }) => ({
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
}));
